import { cn, twVariants } from '@kiiwi/ui';
import React, { HTMLAttributes } from 'react';
import { VariantProps } from '@/components/ui/not-existing-kiiwi-components/utils';

const avatarStyles = twVariants({
  base: 'rounded-full bg-cover block',
  variants: {
    size: {
      xs: 'h-4 w-4',
      sm: 'h-5 w-5',
      md: 'h-6 w-6',
      lg: 'h-7 w-7',
      xl: 'h-8 w-8',
      '2xl': 'h-9 w-9',
      '3xl': 'h-10 w-10',
    },
  },
});

type AvatarProps = HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof avatarStyles> & { src: string };

const Avatar = ({
  className,
  size = 'md',
  src,
  children,
  ...props
}: AvatarProps) => {
  // notes: using <img> make the image blink on state change (chrome 126...)
  return (
    <span
      // use style because tailwind does not handle dynamic value
      style={{
        backgroundImage: `url(${src})`,
      }}
      className={cn(avatarStyles({ size }), className)}
      {...props}
    />
  );
};

Avatar.displayName = 'Avatar';

export { Avatar, avatarStyles };
